var map = {
	"./br/PT/S1/fjbg2.jpg": 4028,
	"./fjbg2.jpg": 45999,
	"./in/EN/S1/fjbg2.jpg": 5801,
	"./ph/EN/S1/fjbg2.jpg": 13302,
	"./ph/EN/S2/fjbg2.jpg": 34436,
	"./vn/VI/S1/fjbg2.jpg": 46975
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93077;